// extracted by mini-css-extract-plugin
export default {"prompts":"Prompts_prompts__4ZhMm"};